
export const rechargeUtil = {

  async getRechargeData() {
    
    const session = await recharge.auth.loginShopifyAppProxy();
    const { addresses } = await recharge.address.listAddresses(
      session,
      { include: ['subscriptions'] }
    );
    window.mosaic.recharge = window.mosaic.recharge || {};
    const address = addresses[0];
    window.mosaic.recharge.address = address;
    window.mosaic.recharge.subscriptions = address.include.subscriptions;
  },

  getBundleParent() {
    return window.mosaic.recharge.subscriptions.find(
      sub => Number(sub.external_product_id.ecommerce) === window.themeConfiguration.bundleArchitecture.product.id
    );
  },

  async getBundleSelection() {

    if (window.mosaic.recharge.bundleSelection) {
      return window.mosaic.recharge.bundleSelection;
    }

    const bundleParent = this.getBundleParent();

    if (!bundleParent) {
      console.error('No bundle subscription found');
      return [];
    }
    const session = await recharge.auth.loginShopifyAppProxy();
    const {bundle_selections} = await window.recharge.bundle.listBundleSelections(
      session,
      {
        purchase_item_ids: bundleParent.id.toString() 
      },
    );
    window.mosaic.recharge.bundleSelection = bundle_selections[0];
    return bundle_selections[0];
  },

  async getBundleConfig() {

    const bundleConfigRaw = await recharge.cdn.getCDNBundleSettings(
      window.themeConfiguration.bundleArchitecture.product.id
    )

    const collectionLimitsRaw = bundleConfigRaw.variants[0].option_sources;

    const collectionLimits = {};
    collectionLimitsRaw.forEach((collection) => {
      if (collection?.quantity_max != null) {
        const collectionId = collection.collection_id;
        collectionLimits[collectionId] = {
          max: collection.quantity_max,
        };
      }
    });

    return { collectionLimits };
  },
};
